export default __webpack_public_path__ + "static/media/soft13.ba920fa2.jpg";